<template>
    <div>
        <highcharts
            :constructor-type="'chart'"
            :options="chartOptions"
            ref="highcharts"
        ></highcharts>
    </div>
</template>
<script>
export default {
    props: ['historicSalesDiary', 'historicStocksDiary'],
    methods: {},
    data() {
        return {
            chartOptions: {
                chart: {
                    zoomType: 'xy',
                    height: '150px'
                },
                title: {
                    text: ''
                },
                xAxis: {
                    type: 'datetime',
                    dateTimeLabelFormats: {
                        month: '%b %y',
                        year: '%Y'
                    },
                    title: {
                        text: 'Date'
                    }
                },
                yAxis: [
                    {
                        // Primary yAxis
                        labels: {
                            format: '{value}',
                            style: {
                                color: Highcharts.getOptions().colors[1]
                            }
                        },
                        title: {
                            text: 'Estoque',
                            style: {
                                color: Highcharts.getOptions().colors[1]
                            }
                        }
                    },
                    {
                        // Secondary yAxis
                        title: {
                            text: 'Vendas',
                            style: {
                                color: Highcharts.getOptions().colors[0]
                            }
                        },
                        labels: {
                            format: '{value}',
                            style: {
                                color: Highcharts.getOptions().colors[0]
                            }
                        },
                        opposite: true
                    }
                ],
                tooltip: {
                    shared: true
                },
                credits: {
                    enabled: false
                },
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                },
                series: []
            }
        }
    },
    watch: {
        historicSalesDiary: {
            handler: function(val) {
                const chart = this.$refs.highcharts.chart
                chart.addSeries({
                    name: 'Vendas',
                    type: 'spline',
                    data: val
                })
            },
            deep: true
        },

        historicStocksDiary: {
            handler: function(val) {
                const chart = this.$refs.highcharts.chart
                chart.addSeries({
                    name: 'Estoque',
                    type: 'column',
                    yAxis: 1,
                    data: val
                })
            },
            deep: true
        }
    }
}
</script>
